import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { ToastService, ToastSettings } from './toast.service';
import { DxToastModule } from 'devextreme-angular';

@Component({
    selector: 'ep-toast',
    templateUrl: './toast.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxToastModule]
})
export class ToastComponent implements OnInit {

    @ViewChild('toastInstance', { static: true })
    toastInstance: any;

    constructor(private toastService: ToastService) { }

    ngOnInit() {
        this.toastService.toastObserver.subscribe((settings: ToastSettings) => {
            // Databinding is not fully implemented in the dx-toast widget at the momemt, so we need to call the api method 'option'.
            this.toastInstance.instance.option('type', settings.type);
            this.toastInstance.instance.option('displayTime', settings.timeToShowMs);
            this.toastInstance.instance.option('message', settings.text);
            this.toastInstance.instance.show();
        });
    }
}